import { formatRoomClinic } from "utils/rooms.util";

import { emptySplitApi } from "./empty-split-api";
import { Room, RoomsResponse } from "./types/rooms.type";

export const ROOM_QUERY = "{id,name,type}";

const extendedRoomsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRooms: builder.query<
      RoomsResponse,
      { clinic?: number; query?: string; is_active?: boolean | null }
    >({
      query: (params) => ({ url: "rooms/?limit=300", params }),
      providesTags: (result) =>
        result?.map((room) => ({
          type: "Rooms" as const,
          id: room.id
        })) ?? [],
      transformResponse: (response: RoomsResponse) =>
        response.map(formatRoomClinic)
    }),
    getRoom: builder.query<Room, number>({
      query: (id) => `rooms/${id}/`,
      providesTags: (result) => [
        {
          type: "Rooms" as const,
          id: result?.id
        }
      ],
      transformResponse: (response: Room) => formatRoomClinic(response)
    }),
    createRoom: builder.mutation<
      Room,
      { name: string; clinic: number; type?: number }
    >({
      query: (body) => ({ url: `/rooms/`, body, method: "POST" }),
      invalidatesTags: ["Rooms"]
    }),
    updateRoom: builder.mutation<
      Room,
      { id: number; name: string; clinic: number }
    >({
      query: ({ id, ...body }) => ({
        url: `/rooms/${id}/`,
        body,
        method: "PATCH"
      }),
      invalidatesTags: ["Rooms"]
    }),
    deleteRoom: builder.mutation<Room, number>({
      query: (id) => ({ url: `/rooms/${id}/`, method: "DELETE" }),
      invalidatesTags: ["Rooms"]
    }),
    getClinicRooms: builder.query<RoomsResponse, number | undefined | null>({
      query: (clinicId) => `rooms/?clinic=${clinicId ?? ""}&limit=300`,
      providesTags: (result) =>
        result?.map((room) => ({
          type: "Rooms" as const,
          id: room.id
        })) ?? [],
      transformResponse: (response: RoomsResponse) =>
        response.map(formatRoomClinic)
    })
  })
});

export const {
  useGetRoomQuery,
  useGetClinicRoomsQuery,
  useUpdateRoomMutation,
  useCreateRoomMutation,
  useDeleteRoomMutation,
  useGetRoomsQuery
} = extendedRoomsApi;
